export { client } from './services/apolloService';

export const ProcessGraphQLError = ({ graphQLErrors, networkError, ...rest }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.log(message);
    });
  }
  if (rest) {
    console.log(rest);
  }
};
